import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin, Select } from 'antd';
import { capitalize } from '../../redux/actions/customFunction';
import { formItemLayout, tailFormItemLayout, handleBackendFormErrors } from '../../common_functions';

const ImgDescFields = props => {
  const { section, section_2, id } = useParams();
  const [ImgDesc, setImgDesc] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const formRef = useRef('');
  const [fields, setFields] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let tab = section_2.replaceAll('-', ' ');
        let newId = id !== 'new' && id;
        let new_choices = [];

        setActiveTab(tab);
        formRef.current.setFieldsValue({ type: tab });

        let { data: { meta: { options: { choices = [] } = {} } = {} } = {} } = await props.fetchFieldValues('support_table', {
          fields: ['fields'],
        });

        // Create the new array for fields
        choices.forEach(item => {
          if (item.text.toLowerCase().includes(tab) || item.text.toLowerCase().includes(tab.split(' ')[0])) {
            new_choices.push(item);
          }
        });

        setFields(new_choices);

        if (section && newId) {
          let respData = await props.getItem('support_table', newId);
          setImgDesc(respData.data);
          formRef.current.setFieldsValue(respData.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    try {
      setLoading(true);
      let newState = { ...ImgDesc, ...values };
      await props.saveItem('support_table', newState);

      let supType = capitalize(section_2.replaceAll('-', ' '));
      notification['success']({
        message: supType + ' saved successfully!',
        duration: 2,
      });
      localStorage.setItem('TabActive', supType);

      setTimeout(() => props.history.push('/settings/image-description', 1500));
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    let supType = section_2.replaceAll('-', ' ');
    localStorage.setItem('TabActive', supType);
    setTimeout(() => props.history.push('/settings/image-description', 1500));
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/image-description" }, { title: "Image Description", href: "/settings/image-description" }, { title: id !== 'new' ? `Edit ${capitalize(activeTab)}` : `Add ${capitalize(activeTab)}` }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit ${capitalize(activeTab)}: ${id}` : `Add ${capitalize(activeTab)}`}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              {id !== 'new' ? (
                <Row gutter={24}>
                  {' '}
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="id" label="ID(System Generated)">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="fields"
                      label="Field Name"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Field Name is required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select field name"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      >
                        {fields.map(el => (
                          <Select.Option key={el.value} value={el.value}>
                            {el.text}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="type"
                      label="Type"
                      rules={[
                        {
                          required: true,
                          message: 'Type is required!',
                        },
                      ]}
                    >
                      <Input readOnly placeholder={activeTab} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="fields"
                      label="Field Name"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Field Name is required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select field name"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      >
                        {fields.map(el => (
                          <Select.Option key={el.value} value={el.value}>
                            {el.text}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter the name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="code" label="Code">
                    <Input placeholder="Enter the code" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="source" label="Source">
                    <Input placeholder="Enter the source" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea placeholder="Enter the description" autosize={{ minRows: 3 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={backButton}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_image_description, !!ImgDesc ? ImgDesc.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default ImgDescFields;
